import { LocationData } from "../../components/LocationInput";

export interface EditFormFields {
  mileage: string;
  price: string;
  description: string;
  exteriorColor: string;
  interiorColor: string;
  titleStatus: string;
  location: LocationData | null;
}

function normalizeNumberString(value: string): string {
  const n = parseFloat(value);
  return Number.isFinite(n) ? String(n) : value.trim();
}

function locationsEqual(
  a: LocationData | null | undefined,
  b: LocationData | null | undefined
): boolean {
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  return (
    a.address === b.address &&
    Number(a.latitude) === Number(b.latitude) &&
    Number(a.longitude) === Number(b.longitude)
  );
}

/** True when the edit form differs from the snapshot loaded from the server. */
export function isEditFormDirty(
  current: EditFormFields,
  original: EditFormFields | null
): boolean {
  if (!original) return false;
  return (
    normalizeNumberString(current.mileage) !==
      normalizeNumberString(original.mileage) ||
    normalizeNumberString(current.price) !==
      normalizeNumberString(original.price) ||
    current.description !== original.description ||
    current.exteriorColor !== original.exteriorColor ||
    current.interiorColor !== original.interiorColor ||
    current.titleStatus !== original.titleStatus ||
    !locationsEqual(current.location, original.location)
  );
}

export function cloneEditFormFields(data: EditFormFields): EditFormFields {
  return {
    ...data,
    location: data.location ? { ...data.location } : null,
  };
}
